import script from "./gain-list-items.vue?vue&type=script&setup=true&lang=js"
export * from "./gain-list-items.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__